<div class="faq-selfcare-area">
    <div class="faq" *ngIf="motive.faqs">
        <span class="title"
        [innerHTML]="'pt.edp.edponline.requests-and-operations.creation.side-bar.step2.faqs-and-selfcare.faqtitle' | translate"></span>
        <ng-container *ngFor="let faq of motive.faqs">
            <a class="card d-none d-wdgt-flex" [edpExternalLink]="faq.url" [href]="faq.url" [gaClickDatalayer]="'clickOpenLink'"
                [extraGaClickDatalayer]="{
                    formModal: faq.url,
                    interactionName: getFormattedName(faq.title),
                    interactionLocation: 'criar-pedido-modal'
                }"
            >
                <div class="card-body d-flex">
                    <div class="card-content">
                        <span class="card-content-title" [innerHTML]="faq.title | translate"></span>
                        <span>
                            <i class="icon-edponline-Bop-024 card-content-icon"></i>
                        </span>
                    </div>
                </div>
            </a>
        </ng-container>
        <ngx-slick-carousel class="carousel d-block d-wdgt-none w-100" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let faq of motive.faqs" class="slide">
                <a class="card" [edpExternalLink]="faq.url" [href]="faq.url" [gaClickDatalayer]="'clickOpenLink'"
                    [extraGaClickDatalayer]="{
                        formModal: faq.url,
                        interactionName: getFormattedName(faq.title),
                        interactionLocation: 'criar-pedido-modal'
                    }"
                >
                    <div class="card-body d-flex">
                        <div class="card-content">
                            <span class="card-content-title" [innerHTML]="faq.title | translate"></span>
                            <span>
                                <i class="icon-edponline-Bop-024 card-content-icon"></i>
                            </span>
                        </div>
                    </div>
                </a>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="selfcare" *ngIf="isSelfcare">
        <span class="title"
        [innerHTML]="'pt.edp.edponline.requests-and-operations.creation.side-bar.step2.faqs-and-selfcare.selfcaretitle' | translate"></span>
        <a class="card" (click)="getLink()">
            <div class="card-body d-flex">
                <div class="card-content">
                    <span class="card-content-title">
                        {{ !labelReturnAction ? motive.action : (labelReturnAction | translate) }}
                    </span>
                    <span>
                        <i class="icon-edponline-Bop-073 rotate-270 card-content-icon"></i>
                    </span>
                </div>
            </div>
        </a>
    </div>
</div>